import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import { useDispatch } from "react-redux";

import { v4 as uuidv4 } from "uuid"; // Import uuid library

const Datatable = ({
  entries,
  onEdit,
  onDelete,
  appointmentType,
  activeTab,
}) => {
  return (
    <div className="overflow-x-auto text-sm text-black">
      <table className="min-w-full bg-white border-gray-200">
        <thead className="font-semibold">
          <tr className="bg-gray-100 border-b">
            <th className="text-left py-2 px-3 border-r">SNo.</th>
            <th className="text-left py-2 px-3 border-r">ID Name</th>
            <th className="text-left py-2 px-3 border-r hidden">ID Type</th>

            <th className="text-left py-2 px-3 border-r">ID No</th>
            <th className="text-left py-2 px-3 border-r">Name</th>
            <th className="text-left py-2 px-3 border-r">नाम</th>
            <th className="text-left py-2 px-3 border-r">Relation</th>
            <th className="text-left py-2 px-3 border-r">Relative</th>
            <th className="text-left py-2 px-3 border-r"> रिश्तेदार</th>
            <th className="text-left py-2 px-3 border-r">Gender</th>
            <th className="text-left py-2 px-3 border-r hidden">Occupation</th>
            <th className="text-left py-2 px-3 border-r">Occupation Name</th>
            <th className="text-left py-2 px-3 border-r">Country</th>
            <th className="text-left py-2 px-3 border-r">Mobile</th>
            <th className="text-left py-2 px-3 border-r">Email</th>
            <th className="text-left py-2 px-3 border-r">Date</th>
            <th className="text-left py-2 px-3 border-r">House No</th>
            <th className="text-left py-2 px-3 border-r">Locality</th>
            <th className="text-left py-2 px-3 border-r">Area</th>
            <th className="text-left py-2 px-3 border-r hidden">State</th>
            <th className="text-left py-2 px-3 border-r">State Name</th>
            <th className="text-left py-2 px-3 border-r hidden">District</th>
            <th className="text-left py-2 px-3 border-r">District Name</th>
            <th className="text-left py-2 px-3 border-r">Pincode</th>
            {/* {appointmentType === "L" && activeTab !== "witness" && ( */}
            {activeTab !== "witness" && (
              <>
                <th className="text-left py-2 px-3 border-r">POA Date</th>
                <th className="text-left py-2 px-3 border-r">Office</th>
                <th className="text-left py-2 px-3 border-r">Document No</th>
                <th className="text-left py-2 px-3 border-r">POA Year</th>
                <th className="text-left py-2 px-3 border-r">
                  RegistrationFor
                </th>
                <th className="text-left py-2 px-3 border-r">Regcode</th>
              </>
            )}

            <th className="text-left py-2 px-3 border-r hidden">GenderCode</th>
            <th className="text-left py-2 px-3 border-r hidden">VTC</th>
            <th className="text-left py-2 px-3 border-r hidden">paN_Form60</th>
            <th className="text-left py-2 px-3 border-r">PAN</th>
            <th className="text-left py-2 px-3 border-r">Form60</th>
            <th className="text-left py-2 px-3 border-r">Action</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr key={index} className="border-b">
              <td className="text-left py-2 px-3 border-r">{index + 1}</td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.id_Type_Code}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.idName}</td>
              <td className="text-left py-2 px-3 border-r">{entry.id_No}</td>
              <td className="text-left py-2 px-3 border-r">{entry.name_Eng}</td>
              <td className="text-left py-2 px-3 border-r">{entry.name_Hin}</td>
              <td className="text-left py-2 px-3 border-r">{entry.relation}</td>
              <td className="text-left py-2 px-3 border-r">
                {entry.father_Name_Eng}
              </td>
              <td className="text-left py-2 px-3 border-r">
                {entry.father_Name_Hin}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.gender}</td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.occu_Code}
              </td>
              <td className="text-left py-2 px-3 border-r">
                {entry.occupation}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.country}</td>
              <td className="text-left py-2 px-3 border-r">
                {entry.mobile_No}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.email}</td>
              <td className="text-left py-2 px-3 border-r">{entry.dob}</td>
              <td className="text-left py-2 px-3 border-r">{entry.house_no}</td>
              <td className="text-left py-2 px-3 border-r">{entry.landmark}</td>
              <td className="text-left py-2 px-3 border-r">{entry.street}</td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.state}
              </td>
              <td className="text-left py-2 px-3 border-r">
                {entry.stateName}
              </td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.district}
              </td>
              <td className="text-left py-2 px-3 border-r">
                {entry.districtName}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.pincode}</td>
              {/* {appointmentType === "L" && activeTab !== "witness" && ( */}
              {activeTab !== "witness" && (
                <>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.POADate || "-"}
                  </td>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.Office || "-"}
                  </td>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.DocumentNo || "-"}
                  </td>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.POAYear || "-"}
                  </td>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.Registration_For || "-"}
                  </td>
                  <td className="text-left py-2 px-3 border-r">
                    {entry.Reg_Code || "-"}
                  </td>
                </>
              )}

              <td className="text-left py-2 px-3 border-r hidden">
                {entry.gendeR_CODE}
              </td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.vtc}
              </td>
              <td className="text-left py-2 px-3 border-r hidden">
                {entry.paN_Form60}
              </td>
              <td className="text-left py-2 px-3 border-r">{entry.paN_no}</td>
              <td className="text-left py-2 px-3 border-r">{entry.form60}</td>
              <td className="text-left py-2 px-3 border-r">
                <button onClick={() => onEdit(entry.id)}>
                  <FaEdit className="text-blue-500 hover:text-blue-700 mx-1" />
                </button>
                <button onClick={() => onDelete(entry.id)}>
                  <FaTrash className="text-red-500 hover:text-red-700 mx-1" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Datatable;
